module.exports = __webpack_public_path__ + "78299fe2873624579da42e9c56cb3dc2.MP3";